module.exports = __webpack_public_path__ + "static/media/numbermatka.1b1266a5.jpeg";